'use client';

import {Global} from '@emotion/react';

import {SnackbarProvider} from 'Snackbar';

import {fonts} from './fonts';

import type {PropsWithChildren} from 'common';
import type {SnackbarProviderProps} from 'Snackbar';

type ThemeProviderProps = {
  /** Добавить шрифты X5 Sans */
  withFonts?: boolean;
  snackbarProps?: SnackbarProviderProps;
} & PropsWithChildren;

/** Тема, несовместима с Next.js (используйте ThemeProviderNext)
 *
 * добавляет SnackbarProvider
 */
export const ThemeProvider: React.FC<ThemeProviderProps> = ({children, withFonts, snackbarProps}) => (
  <SnackbarProvider {...snackbarProps}>
    {withFonts && <Global styles={fonts} />}
    {children}
  </SnackbarProvider>
);
